export var fullscreenFixedOptions = {
    allowDownload: false,
    allowSocial: false,
    loveButton: false,
    isStoreGallery: false,
    loveCounter: true,
    allowTitle: true,
    allowTitleExpand: true,
    allowDescriptionExpand: true,
    allowLinkExpand: false,
    allowFullscreenExpand: true,
    allowExifExpand: false,
    defaultShowInfoExpand: true,
    showInfoExpandButton: false,
    expandInfoPosition: 'SIDE',
    addToCartButtonText: '',
    galleryAlignExpand: 'left',
    fullscreenLoop: false,
    mobileSwipeAnimation: 'EXPAND',
    enableFullscreenVideoPlaceholder: true,
    allowFullscreenMagnifyImage: false,
    fullscreenMagnificationLevel: 2,
    allowBackgroundGradient: false,
    backgroundGrayscaleFilter: false,
    backgroundBlurFilter: 1,
    backgroundGradientDegrees: 180,
    stylingParams: {
        itemResolutionMode: 'SCALED_DOWN',
    }
};
//# sourceMappingURL=fullscreenFixedStyles.js.map